"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavigationTracker = void 0;
var React = require("react");
var RootReducer_1 = require("../../app/RootReducer");
var styles = require("../../styles/NavigationPanel");
var VerticalLine_1 = require("./VerticalLine");
var NavigationTracker = function (_a) {
    var navigationItems = _a.navigationItems;
    var subspace = (0, RootReducer_1.useAppSelector)(function (state) { return state.subspace; }).subspace;
    // Use activeIndex to immediately set index for visual effect.
    // The redux store access gives us a tiny delay after click / component re-render
    var _b = React.useState(subspace), activeIndex = _b[0], setActiveIndex = _b[1];
    React.useEffect(function () {
        setActiveIndex(subspace);
    }, [subspace]);
    var getMenuCircleBackgroundColor = function (item, index) {
        if (activeIndex === index) {
            return styles.NAVIGATION_ACTIVE_COLOR;
        }
        return item.disabled ? styles.NAVIGATION_DISABLED_COLOR : styles.NAVIGATION_ENABLED_COLOR;
    };
    var onTextClick = function (item, index) {
        if (item.disabled) {
            return;
        }
        setActiveIndex(index);
        item.onClick();
    };
    return (React.createElement("div", { className: styles.navTrackerContainer }, navigationItems.map(function (item, itemIndex) {
        var circleBgColor = getMenuCircleBackgroundColor(item, itemIndex);
        var textCssClass = [styles.navRow];
        if (!item.disabled) {
            textCssClass.push(styles.navTextClickable);
        }
        if (itemIndex === activeIndex) {
            textCssClass.push(styles.navTextHighlighted);
        }
        return (React.createElement("div", { className: styles.navMenuContainer, key: "navigation_menu_".concat(item.subspace) },
            React.createElement("div", { className: "".concat(textCssClass.join(' ')), onClick: function () { return onTextClick(item, itemIndex); }, onKeyPress: function (event) { return event.key === 'Enter' && onTextClick(item, itemIndex); }, role: "button", tabIndex: 0, "data-tb-test-id": item.testId },
                React.createElement("div", { className: styles.navMenuCircle, style: { backgroundColor: circleBgColor } },
                    React.createElement("span", null, item.icon)),
                React.createElement("div", { className: styles.navMenuText }, item.header)),
            item.submenu !== undefined && item.subspace === subspace && item.submenu,
            itemIndex !== navigationItems.length - 1 && React.createElement(VerticalLine_1.default, null)));
    })));
};
exports.NavigationTracker = NavigationTracker;
//# sourceMappingURL=NavigationTracker.js.map